import { Router } from '@angular/router';
import { ConstantsService } from '../constants/constants.service';
import { inject } from '@angular/core';

export const AuthGuard = () => {

  const constants = inject(ConstantsService);
  const router = inject(Router);

  const storage = constants.getSessionStorage();
  if (storage && storage.getItem('currentUser')) {
    return true;
  }else{
    return router.createUrlTree(['/login']); // Redirect to login
  }
};